const state = () => ({
  min: null,
  max: null,
})

const actions = {
  setHorimetroMin({ commit }, value) {
    commit('SET_HORIMETRO_MIN', value)
  },
  setHorimetroMax({ commit }, value) {
    commit('SET_HORIMETRO_MAX', value)
  },
  clearHorimetro({ commit }) {
    commit('CLEAR_HORIMETRO')
  },
}

const mutations = {
  SET_HORIMETRO_MIN(state, value) {
    state.min = value
  },
  SET_HORIMETRO_MAX(state, value) {
    state.max = value
  },
  CLEAR_HORIMETRO(state) {
    state.min = null
    state.max = null
  },
}

const getters = {
  getHorimetroMin: (state) => state.min,
  getHorimetroMax: (state) => state.max,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
